import { TICKET_STATUS_ORDER, TICKET_STATUS_META, TICKET_PRIORITY_META } from "./supportMeta";

export const TicketKanbanBoard = ({ columns, onSelectTicket }) => (
  <div className="flex gap-3 overflow-x-auto pb-2" data-testid="support-kanban-board">
    {TICKET_STATUS_ORDER.map((status) => {
      const col = columns[status] || { count: 0, tickets: [] };
      return (
        <div key={status} className="w-60 shrink-0" data-testid={`support-kanban-column-${status}`}>
          <div className="mb-2 flex items-center justify-between">
            <span className={`rounded-full border px-2.5 py-1 text-xs font-bold ${TICKET_STATUS_META[status].cls}`}>{TICKET_STATUS_META[status].label}</span>
            <span className="text-xs font-bold text-slate-400" data-testid={`support-kanban-count-${status}`}>{col.count}</span>
          </div>
          <div className="space-y-2">
            {col.tickets.length === 0 ? (
              <p className="rounded-xl border border-dashed border-slate-200 p-4 text-center text-xs text-slate-400 dark:border-white/10">No tickets</p>
            ) : col.tickets.map((t) => (
              <button
                key={t.ticket_id}
                type="button"
                onClick={() => onSelectTicket(t)}
                data-testid={`support-kanban-card-${t.ticket_id}`}
                className="block w-full rounded-xl border border-slate-200 bg-white p-3 text-left shadow-sm transition-shadow duration-150 hover:shadow-md dark:border-white/10 dark:bg-[#111C33]"
              >
                <p className="truncate text-sm font-bold text-slate-900 dark:text-white">{t.subject}</p>
                <p className="mt-0.5 truncate text-xs text-slate-500 dark:text-slate-400">{t.customer_name}</p>
                <p className="truncate text-[10px] text-slate-400" title={t.display_id}>{t.display_id}</p>
                <div className="mt-2 flex items-center justify-between">
                  <span className={`rounded-full border px-2 py-0.5 text-[10px] font-bold ${TICKET_PRIORITY_META[t.priority].cls}`}>{TICKET_PRIORITY_META[t.priority].label}</span>
                  {t.escalated && <span className="text-[10px] font-bold text-red-500">Escalated</span>}
                </div>
              </button>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);
